import { render, staticRenderFns } from "./ValidaCertificado.vue?vue&type=template&id=58580f54&"
import script from "./ValidaCertificado.vue?vue&type=script&lang=js&"
export * from "./ValidaCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports